webpackJsonp([162898551421021],{

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(76);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _gatsbyConfig = __webpack_require__(4);
	
	var _gatsbyConfig2 = _interopRequireDefault(_gatsbyConfig);
	
	var _appHelpers = __webpack_require__(5);
	
	var _forms = __webpack_require__(56);
	
	var _siteFooter = __webpack_require__(7);
	
	var _siteFooter2 = _interopRequireDefault(_siteFooter);
	
	var _siteHeader = __webpack_require__(8);
	
	var _siteHeader2 = _interopRequireDefault(_siteHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = _gatsbyConfig2.default.siteMetadata;
	
	var Status404Page = function (_React$Component) {
	  _inherits(Status404Page, _React$Component);
	
	  function Status404Page() {
	    _classCallCheck(this, Status404Page);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.state = { isBusy: false };
	    return _this;
	  }
	
	  Status404Page.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window === 'undefined') return;
	    var trip = this.props.trip;
	
	
	    this.validateDataKeys = Object.keys(Status404Page.BLANK_FORM_DATA);
	    this.liveChecking = false;
	  };
	
	  Status404Page.prototype.onInputChange = function onInputChange() {
	    this.data = (0, _forms.saveData)('lsg.report-error-data');
	    if (this.liveChecking) {
	      (0, _forms.validateRequired)('lsg.report-error-data', this.validateDataKeys);
	    }
	  };
	
	  Status404Page.prototype.submit = function submit() {
	    this.data = (0, _forms.saveData)('lsg.report-error-data');
	    if (!(0, _forms.validateRequired)('lsg.report-error-data', this.validateDataKeys)) {
	      this.liveChecking = true;
	      return;
	    }
	    var path = window.location.pathname;
	    var trip = path.replace(/^\/([a-z0-9]+)\/.*/i, '$1');
	    var tripData = config.trips[trip] || {};
	    var formEl = (0, _appHelpers.getEl)('.report-error form');
	    var endpoint = ("https://wt-a7eb5d2bc87b683d3d2b87e61385eaab-0.sandbox.auth0-extend.com/report-error");
	    var _window$location = window.location,
	        protocol = _window$location.protocol,
	        hostname = _window$location.hostname,
	        port = _window$location.port;
	
	    var params = _extends({}, this.data, {
	      trip: trip,
	      error: '404: Page not found',
	      currentURL: window.location.href,
	      referringURL: document.referrer,
	      returnPathRoot: protocol + '//' + hostname + (port ? ':' + port : '') + '/' + trip,
	      tripDates: tripData ? tripData.dates : '',
	      tripName: tripData ? tripData.name : '',
	      tripYear: tripData ? tripData.year : '',
	      tripRegion: tripData ? tripData.region : '',
	      tripVenue: tripData ? tripData.venue : ''
	    });
	    var keyPairs = [];
	    for (var key in params) {
	      keyPairs.push(key + '=' + encodeURIComponent(params[key]));
	    }
	
	    formEl.classList.remove('sent', 'failed');
	    this.setState({ isBusy: true });
	    _axios2.default.post(endpoint + '?' + keyPairs.join('&'), {
	      headers: config.axiosHeaders
	    }).then(function () {
	      formEl.classList.add('sent');
	      formEl.reset();
	      (0, _appHelpers.setInLocal)('lsg.report-error-data', JSON.stringify(Status404Page.BLANK_FORM_DATA));
	    }).catch(function () {
	      formEl.classList.add('failed');
	    }).finally(function () {
	      this.setState({ isBusy: false });
	    }.bind(this));
	  };
	
	  Status404Page.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = _extends({}, Status404Page.BLANK_FORM_DATA);
	    try {
	      var raw = localStorage.getItem('lsg.report-error-data');
	      if (raw) data = JSON.parse(raw);
	    } catch (err) {}
	    var isBusy = this.state.isBusy;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'page-at-root page-404' },
	      _react2.default.createElement(_siteHeader2.default, { trip: 'none' }),
	      _react2.default.createElement(
	        'main',
	        { className: 'report-error form' },
	        _react2.default.createElement(
	          'form',
	          {
	            onSubmit: function onSubmit(e) {
	              return e.preventDefault();
	            },
	            'data-sent': 'Thank you!',
	            'data-failed': 'Whoops. We had a problem sending your report. Please try again...'
	          },
	          isBusy ? _react2.default.createElement(
	            'div',
	            { className: 'loader-mask' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Sending Report'
	            ),
	            _react2.default.createElement('div', { className: 'loader' })
	          ) : '',
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Page Not Found'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Please let us know how you arrived here. What website did you come from and, if possible, what link did you click? Your help would be greatly appreciated.'
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  { className: 'field' },
	                  _react2.default.createElement('textarea', {
	                    name: 'message',
	                    onChange: this.onInputChange.bind(this),
	                    defaultValue: data.message
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'button-bar full' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn-primary', onClick: function onClick(e) {
	                      return _this2.submit(e);
	                    } },
	                  'Send Report'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_siteFooter2.default, null)
	    );
	  };
	
	  return Status404Page;
	}(_react2.default.Component);
	
	Status404Page.BLANK_FORM_DATA = {
	  message: ''
	};
	exports.default = Status404Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-998867d78498cd07629c.js